import { useState, useEffect,useRef } from "react";
import ReactDatetime from "react-datetime";
import React from 'react';
import moment from 'moment';
import {
  Button,
  Card,
  Table,
  Container,
  CardFooter,
  Row,
  Input,
  Pagination,
  PaginationItem,
  PaginationLink,
  FormGroup,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
} from "reactstrap";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-community/dist/styles/ag-theme-alpine-dark.css";
import "../../assets/css/custom.css";
import Header from "components/Headers/Header.js";
import { clientmanageService } from "../../services/clientmanageService.js";
import 'assets/css/themecustom-style.css';
import { toast } from 'react-toastify';
import { useHistory,useParams } from "react-router-dom";
import Select from 'react-select';
const axios = require("axios");
import { usermanageService } from "../../services/usermanageService";

import { taskmanageService } from "../../services/taskmanageService";

const FeedbackChecklist = (props) => {
  const params  = useParams();
  const user_info = JSON.parse(localStorage.getItem("user-info"));
  const [trans_data,settransData] = useState([]);
  const [state, setState] = useState({startDate:'',endDate:''});
  const [statesend, setStatesend] = useState({startDate:'',endDate:''});

  const history = useHistory();
  // Set by the separate Phase Rejections report for A&S TLs (BRD 6499).
  const phaseRejections = !!props.phaseRejections;
  // The full QA + phase column set.
  const isFullView = phaseRejections || [2, 3, 12, 14].includes(Number(user_info.role_id));
  // Who can edit the rejection-tracking columns.
  const canTrack = phaseRejections || user_info.role_id == 14;
  const [loading, setLoading] = useState(false);
  const [feedbackOptions, setFeedbackOptions] = useState({responsibility: [], status: [], phases: []});
useEffect(() => {
  getTransitionData();
  getclient_list();
  taskmanageService.getFeedbackOptions().then((response) => {
    if(response && response.status == 200){
      setFeedbackOptions(response.data);
    }
  });
}, []);
const [currentPage, setCurrentPage] = useState(null);
  const [last_page, setLastPageData] = useState(0);
  const handlePageClick = (e, index) => {
    e.preventDefault();
    getTransitionData(index,applied.filters,applied.startDate,applied.endDate);
  };

  const handlePreviousClick = () => {
    const prev = currentPage - 1;
    getTransitionData(prev,applied.filters,applied.startDate,applied.endDate);
  };

  const handleNextClick = () => {
    const next = currentPage + 1;
    getTransitionData(next,applied.filters,applied.startDate,applied.endDate);
  };

  const getTransitionData = async (pageNumber = 1,filterFields='',start_date='',end_date='') => {
  setLoading(true);
  clientmanageService.getChecklistFeedback(pageNumber,filterFields,start_date,end_date,phaseRejections ? 'getPhaseRejections' : 'getChecklistFeedback').then((response) => {
      
        setLoading(false);
        if(response && response.status === 200){
          settransData(response.data.data.data)
          setCurrentPage(response.data.data.current_page);
          setLastPageData(response.data.data.last_page);
        }else {
          toast.error('Something went wrong!');
        }
    });
  }

  const [clientData, setclientData] = useState([]);
  function getclient_list() {
    usermanageService.getmanager_list().then((response) => {
      setclientData(response.data.client);
    });
  }

  function setclient(e){
    subclientList(e.label)

  }

  const [ subclientlist, setsubclientlist ] = useState([{'label':'Select Sub Client',value:''}])

  function subclientList(clientname=''){
    //setsubclientlist([]);
    clientmanageService.getsubclientlistsearchable(clientname).then((response) => {
        if(response.status === 200){
          setsubclientlist(response.data)
        }else {
          toast.error('Something went wrong!');
        }
    });
  }

  const [filterFields,setfilterFields] = useState([]);
  // Filters from the last Search click; pagination keeps using these.
  const [applied, setApplied] = useState({filters:'',startDate:'',endDate:''});
  const handleSearch = () => {
    setApplied({filters:filterFields,startDate:statesend.startDate,endDate:statesend.endDate});
    getTransitionData(1,filterFields,statesend.startDate,statesend.endDate);
  }
  const companyfilter = (e,index,field) => {
    
    const cloneValues = {...filterFields};
    cloneValues[index] = {
      ...cloneValues[index],
      ['field']: field,
      ['value']: e ? encodeURIComponent(e.label) : '',
      ['operator']: '='
    };
    setfilterFields(cloneValues);
  }
  const searchData = (e,index,field)=>{
    const cloneValues = {...filterFields};
    cloneValues[index] = {
      ...cloneValues[index],
      ['field']: e.target.name,
      ['value']: e.target.value,
      ['operator']: '='
    };
    setfilterFields(cloneValues);
  }
  function downloadReport(){
    clientmanageService.checklist_feedback_report(filterFields,statesend.startDate,statesend.endDate,phaseRejections ? 'phase_rejections' : '').then((response) => {
     
    });
  }
  const handleeditRow = (index) => {
    let temp_state = [...trans_data];
    let temp_element = { ...temp_state[index] };
    temp_element.editing = true;
    temp_state[index] = temp_element;
    settransData(temp_state);
};

function inputhandlerchecklist(e, field, index,id) {
  
  let temp_m = [...trans_data];
  let temp_ele = { ...temp_m[index] };
  var value = e.target.value;
  if(field == 'qa_rejection_date'){
    temp_ele['rejection_date'] = value;
  }
  temp_ele[field] = value;
  temp_ele.editing = false;
  temp_m[index] = temp_ele;
  settransData(temp_m);
  taskmanageService.editChecklistUpdate(value, field, id).then((response) => {
    if(response.status == 200){
            toast.success(response.data.message);
          }else{
              toast.error(response.data.message);
          }
  })
}
function trackinghandler(value, field, index, id) {
  const optionName = (list) => {
    const found = list.find((o) => String(o.id) === String(value));
    return found ? found.name : null;
  };
  let temp_m = [...trans_data];
  let temp_ele = { ...temp_m[index] };
  temp_ele[field] = value;
  if(field == 'responsibility_option_id'){
    temp_ele.responsibility_option = optionName(feedbackOptions.responsibility);
  }
  if(field == 'action_status_id'){
    temp_ele.action_status = optionName(feedbackOptions.status);
  }
  if(field == 'applicable_phase_id'){
    temp_ele.applicable_team = optionName(feedbackOptions.phases);
    temp_ele.is_reallocated = String(value) !== String(temp_ele.team_phase_id) ? 1 : 0;
  }
  temp_ele.editing = false;
  temp_m[index] = temp_ele;
  settransData(temp_m);
  taskmanageService.updateFeedbackTracking(value, field, id).then((response) => {
    if(response && response.status == 200){
      if(response.data.closure_date){
        let rows = [...temp_m];
        rows[index] = { ...rows[index], closure_date: response.data.closure_date };
        settransData(rows);
      }
      toast.success(response.data.message);
    }else{
      toast.error((response && response.data && response.data.message) || 'Something went wrong!');
    }
  })
}
const removeRow = (id,type)=>{
  swal({
    title: "Are you sure want to remove?",
    text: "",
    icon: "warning",
    buttons: true,
    dangerMode: true,
  })
  .then((isConfirm) => {
    if (isConfirm){
    taskmanageService.removeChecklistRow(id,type).then((response) => {
    if(response.status == 200){
    // getTransitionData(1);
    const updatedData = trans_data.filter((item) => item.id !== id);
    settransData(updatedData);

     toast.success(response.data.message);
     //window.location.reload(); 
    }else{
      toast.error(response.data.message);
    }
  });
}
});
}
const [editbox, seteditbox] = useState({ids: []});
const [checkindex, setcheckindex] = useState([]);
const handleOnCheckboxClick = (e,type,index) => {
  const { value, checked } = e.target;
  const { ids } = editbox;
  // Case 1 : The user checks the box
  if (checked) {
    if(value=='all'){
      
      const allIds = trans_data.map(item => item.id);
      seteditbox((prevState) => ({
        ids: [...prevState.ids, ...allIds]  // Add all ids to the existing ones
      }));
      const temp_state = trans_data.map((item) => ({
      ...item,
      rowcheckbox: true  // Mark all as checked
    }));
    
    settransData(temp_state);
    }else{
      seteditbox({
        ids: [...ids, value]
      });
      setcheckindex([...checkindex, index]);
      let temp_state = [...trans_data];
      let temp_element = { ...temp_state[index] };
      temp_element.rowcheckbox = temp_element.rowcheckbox ? false : true;
      temp_state[index] = temp_element;
      settransData(temp_state);
    }
    
  }
  // Case 2  : The user unchecks the box
  else {
    console.log(value)
    if (value === 'all') {
      // If 'Uncheck All' is selected, deselect all checkboxes
      seteditbox({ ids: [] });  // Clear all IDs in seteditbox
      setcheckindex([]);  // Clear checkindex
      const temp_state = trans_data.map((item) => ({
        ...item,
        rowcheckbox: false  // Mark all as unchecked
      }));
      settransData(temp_state);
    } else {
      
      seteditbox({
        ids: ids.filter((e) => e != value)
      });
      setcheckindex(checkindex.filter((e) => e !== index));
    let temp_state = [...trans_data];
      let temp_element = { ...temp_state[index] };
      temp_element.rowcheckbox = temp_element.rowcheckbox ? false : true;
      temp_state[index] = temp_element;
      settransData(temp_state);
  }
  }

  

};
const archieveRows = (type) => {
  console.log(editbox)
  swal({
    title: "Are you sure want to remove?",
    text: "",
    icon: "warning",
    buttons: true,
    dangerMode: true,
  })
  .then((isConfirm) => {
    if (isConfirm){
    taskmanageService.removeChecklistRow(editbox,type).then((response) => {
      console.log
    if(response.status == 200){
      seteditbox({ ids: [] });  // Clear all IDs in seteditbox
      setcheckindex([]); 
    const updatedData = trans_data.filter((item) => !editbox.ids.includes(item.id));
    settransData(updatedData);


     toast.success(response.data.message);
     //window.location.reload(); 
    }else{
      toast.error(response.data.message);
    }
  });
}
});
  // taskmanageService.archiveChecklistFeedback(editbox,type).then((response) => {
  //   if(response.status == 200){
  //     seteditbox({ids: []});
  //     let state = [...dashboarddata];
  //     checkindex.map(element => delete state[element]);
  //     setDashboarddata(state);
  //    toast.success(response.data.message);
  //   }else{
  //     toast.error(response.data.message);
  //   }
  // });
}
console.log(trans_data)
console.log(editbox)

const withouterrorreport = () =>{
  history.push({
    pathname: 'reportwithoutchecklist',
  });
}
function setEndDateRange(e) {
  let dateObj;

  // Check if e is a moment object or a plain JavaScript Date object
  if (e && moment.isMoment(e)) {
    dateObj = e.toDate(); // e is a moment object, so convert to native Date object
  } else if (e && e instanceof Date) {
    dateObj = e; // e is already a Date object, so use it directly
  }

  if (dateObj) {
    const month = dateObj.getMonth() + 1; // months are zero-indexed, so add 1
    const date = dateObj.getDate();
    const year = dateObj.getFullYear();
    const formattedDate = `${date}-${month}-${year}`;
console.log(formattedDate)
    // Update state
    setStatesend({ ...statesend, endDate: formattedDate });
    setState({ ...state, endDate: e });
  } else {
    console.error('Invalid date selected or no date selected.');
  }
};

const setStartDateRange = (e) => {
 // Inspect the value of e
  if (e && e._d) {
    const month = e._d.getMonth() + 1; // months are zero-indexed, so add 1
    const date = e._d.getDate();
    const year = e._d.getFullYear();

    const formattedDate = `${date}-${month}-${year}`;

    setStatesend((prevState) => ({
      ...prevState,
      startDate: formattedDate,
    }));

    setState((prevState) => ({
      ...prevState,
      startDate: e,
    }));
  } else {
    console.error('Invalid date selected or no date selected.');
  }
};
  return (
    <>
      <Header />
      <Container className="mt--7"  fluid>
      <h3>{phaseRejections ? 'Phase Rejections' : 'Checklist Feedback'}</h3>
      {!phaseRejections ?
      <div className="col-2">
             <Button className="col-12 "  type="button" onClick={withouterrorreport}>
                 0 errors jobs report
             </Button> 
             </div>
      :null}
        <Row className="mt-5">
          <div className="col-2">
          <label>Client</label>
        <Select 
          className="input-group-alternative mb-3" 
          name="client"
          searchable 
          options={clientData} // set list of the data
          onChange={(e) => { setclient(e,0,'client');companyfilter(e,1,'client')}}
        /></div><div className="col-2">
        <label>Sub Client</label>
        <Select 
                       
          className="input-group-alternative mb-3" 
          name="sub_client"
          options={subclientlist} // set list of the data
          onChange={(e) => companyfilter(e,1,'sub_client')}
          defaultValue={subclientlist}
          searchable
          isClearable={true}
          /></div>
         
          {/* <label>Date</label>
                      <input type="date"
                            className="form-control"
                            name="date"
                            onChange={(e) =>
                              searchData(e,3,'date')
                              }
                            /> */}
          
  <div style={{display:'flex'}}>
                      <div className="">
                      <label>Start Date</label>
                        <FormGroup>
                          <InputGroup className="input-group-alternative">
                            <InputGroupAddon addonType="prepend">
                              <InputGroupText>
                                <i className="ni ni-calendar-grid-58" />
                              </InputGroupText>
                            </InputGroupAddon>
                            <ReactDatetime
                              inputProps={{
                                placeholder: "YYYY-MM-DD",
                                type: "text", // Allow user to type in text format
                              }}
                              timeFormat={false}
                              dateFormat="YYYY-MM-DD"
                              renderDay={(props, currentDate, selectedDate) => {
                                let classes = props.className;
                                if (
                                  state.startDate &&
                                  state.endDate &&
                                  state.startDate._d + "" === currentDate._d + ""
                                ) {
                                  classes += " start-date";
                                } else if (
                                  state.startDate &&
                                  state.endDate &&
                                  new Date(state.startDate._d + "") <
                                    new Date(currentDate._d + "") &&
                                  new Date(state.endDate._d + "") >
                                    new Date(currentDate._d + "")
                                ) {
                                  classes += " middle-date";
                                } else if (
                                  state.endDate &&
                                  state.endDate._d + "" === currentDate._d + ""
                                ) {
                                  classes += " end-date";
                                }
                                return (
                                  <td {...props} className={classes}>
                                    {currentDate.date()}
                                  </td>
                                );
                              }}
                              onChange={e => setStartDateRange(e)}
                            />
                          </InputGroup>
                        </FormGroup>
                      </div>
                      <div >
                        <label>End Date</label>
                        <FormGroup>
                          <InputGroup className="input-group-alternative">
                            <InputGroupAddon addonType="prepend">
                              <InputGroupText>
                                <i className="ni ni-calendar-grid-58" />
                              </InputGroupText>
                            </InputGroupAddon>
                            <ReactDatetime
                               inputProps={{
                                placeholder: "YYYY-MM-DD",
                                type: "text", // Allow user to type in text format
                              }}
                              timeFormat={false}
                              dateFormat="YYYY-MM-DD"
                              renderDay={(props, currentDate, selectedDate) => {
                                let classes = props.className;
                                if (
                                  state.startDate &&
                                  state.endDate &&
                                  state.startDate._d + "" === currentDate._d + ""
                                ) {
                                  classes += " start-date";
                                } else if (
                                  state.startDate &&
                                  state.endDate &&
                                  new Date(state.startDate._d + "") <
                                    new Date(currentDate._d + "") &&
                                  new Date(state.endDate._d + "") >
                                    new Date(currentDate._d + "")
                                ) {
                                  classes += " middle-date";
                                } else if (
                                  state.endDate &&
                                  state.endDate._d + "" === currentDate._d + ""
                                ) {
                                  classes += " end-date";
                                }
                                return (
                                  <td {...props} className={classes}>
                                    {currentDate.date()}
                                  </td>
                                );
                              }}
                              onChange={e => setEndDateRange(e)}
                            />
                          </InputGroup>
                        </FormGroup>
                      </div >
                      </div>
          <div className="col-2">
          <label>Category</label>
            <Input placeholder="category" id="companydata" name="category"  type="text" style={{fontWeight:"600",color:"black"}}
                onKeyUp={(e) =>searchData(e,4)}  
                /></div>
                <div className="col-2">
                <label>Responsibility</label>
            <Input placeholder="responsibility" id="companydata" name="responsibility"  type="text" style={{fontWeight:"600",color:"black"}}
                onKeyUp={(e) =>searchData(e,5)}  
                /></div>
                
                          <div className="col-2">
             <Button
                      className="col-12 mb-2"
                      color="primary"
                      type="button"
                      onClick={handleSearch}
                      style={{textAlign:'center'}}
                    >
                    <i className="fas fa-search" style={{fontSize:'14px'}}></i> Search
                    </Button>
             <Button
                      className="col-12"
                      type="button"
                      onClick={downloadReport}
                      style={{textAlign:'center'}}
                      title="Download Report"
                    >
                    <i className="fas fa-download" style={{fontSize:'14px'}}></i> Export 
                    </Button>
          </div>
        </Row>  
        <br></br>    
        <Row >
          <div className="col" style={{padding:'0%'}}>
            <Card className="shadow">
            {(editbox.ids.length > 0 && user_info.role_id==14 )?
            <>
              <div>
            <Button
                      className="col-2"
                      type="button"
                      onClick={(e) => archieveRows('phase_rejection')}
                      style={{textAlign:'center'}}
                      
                    >
            <span ><i className="far fa-file-archive"></i> Phase Delete</span></Button>
            <Button
                      className="col-2"
                      type="button"
                      onClick={(e) => archieveRows('qa_rejection')}
                      style={{textAlign:'center'}}
                      
                    >
            <span ><i className="far fa-file-archive"></i> QA Delete</span></Button>
            </div>
            <span className="mt-1" style={{color:'red',fontSize:'12px'}}>*Only QA and Phase selected item Deleted</span>
            </>
            :null}
              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  {user_info.role_id==14 ? 
                  <th><input type="checkbox"
                              name="id"
                              className="rowcheckbox"
                              value="all"
                              
                              onChange={(e) => handleOnCheckboxClick(e)} /></th>:null}
                    <th>Client Name</th>
                    <th scope="col" className="whitespace">Subclient Name</th>
                    <th scope="col" className="whitespace">Team</th>
                    <th scope="col" className="whitespace">Category</th>
                    <th scope="col" className="whitespace">Sub Category</th>
                    <th scope="col" className="whitespace">Responsibility</th>
                   
                    {isFullView ?
                    <>
                    <th scope="col" className="whitespace">Rejection raised by (For QA)</th>
                    <th scope="col" className="whitespace">Rejection for QA</th>
                    <th scope="col" className="whitespace">Rejection date QA</th>
                    <th scope="col" className="whitespace">Rejection Type1 QA</th>
                    <th scope="col" className="whitespace">Rejection Type2 QA</th>
                    <th scope="col" className="whitespace">QA Feedback / Remarks  </th>
                    <th scope="col" className="whitespace">Phase Feedback By  </th>
                    <th scope="col" className="whitespace">Rejection for phase</th>
                    <th scope="col" className="whitespace">Phase Rejection Date  </th>
                    <th scope="col" className="whitespace">Rejection Type1 Phase</th>
                    <th scope="col" className="whitespace">Rejection Type2 Phase</th>
                    <th scope="col" className="whitespace">Phase Feedback  </th>
                    </>
                    :
                    <>

                    <th scope="col" className="whitespace">Phase Feedback By  </th>
                    <th scope="col" className="whitespace">Rejection for phase</th>
                    <th scope="col" className="whitespace">Phase Rejection Date  </th>
                    <th scope="col" className="whitespace">Rejection Type1 Phase</th>
                    <th scope="col" className="whitespace">Rejection Type2 Phase</th>
                    <th scope="col" className="whitespace">Phase Feedback  </th>
                    </>
                    }
                    <th scope="col" className="whitespace">Rejection type </th>
                    <th scope="col" className="whitespace">Amount </th>
                     <th scope="col" className="whitespace">Automation Job </th>
                    {isFullView ?
                    <>
                    <th scope="col" className="whitespace">Responsibility (Rejection)</th>
                    <th scope="col" className="whitespace">Reason</th>
                    <th scope="col" className="whitespace">Applicable Team</th>
                    <th scope="col" className="whitespace">Root Cause</th>
                    <th scope="col" className="whitespace">Action Items</th>
                    <th scope="col" className="whitespace">Status</th>
                    <th scope="col" className="whitespace">Closure Date</th>
                    </>
                    :null}
                    {user_info.role_id==14 || user_info.role_id==2 || user_info.role_id==12 ?
                    <th scope="col" className="whitespace">Action </th>:null}
                    
                </thead>
                <tbody>
           
                { loading ? (
                  <tr><td colSpan="40" style={{padding:'20px'}}><i className="fa fa-spinner fa-spin"></i> Loading...</td></tr>
                ) : trans_data && trans_data.length
                          ?                                
                          trans_data.map((tdata,i) => (
                              <tr key={i} className={((i % 2 == 0)? 'purple-row': 'orange-row' )}
                                style={tdata.is_reallocated == 1 ? {backgroundColor:'#ffe8a3'} : {}}
                                title={tdata.is_reallocated == 1 ? 'Reallocated from '+(tdata.team || '')+' to '+(tdata.applicable_team || '') : undefined}>
                               {user_info.role_id==14 ? 
                               <td><input type="checkbox"
                              name="id"
                              className="rowcheckbox"
                              value={tdata != undefined ? tdata.id : ''}
                              checked={tdata != undefined ? tdata.rowcheckbox : ''}
                              onChange={(e) => handleOnCheckboxClick(e,tdata != undefined ? tdata.edittype : '',i)} /></td>:null} 
                                <td className="whitespace">{tdata.name}</td>
                                <td className="whitespace">{tdata.sub_client}</td>
                                <td className="whitespace">{tdata.team}</td>
                                <td className="whitespace">{tdata.sub_cat}</td>
                                <td className="whitespace">{tdata.category}</td>
                                <td className="whitespace">{tdata.responsibility}</td>
                                <td>{tdata.raised_error_by}</td>
                                <td>{tdata.rejection_tm}</td>
                                 {isFullView ?
                                <>
                                <td onClick={()=> handleeditRow(i)}>
                                  {tdata.editing && (user_info.role_id == 2 || user_info.role_id == 12 || user_info.role_id == 14) ? (
                                  
                                   <input type="date"
                                   className="form-control"
                                     defaultValue={tdata.qa_rejection_date}
                                     onBlur={(e) =>
                                      inputhandlerchecklist(
                                        e,
                                        "qa_rejection_date",
                                        i,tdata.id
                                      )}
                                   />
                                  ) : <span>{tdata.rejection_date}</span> }
                              </td>

                                <td className="whitespace">{tdata.qa_type1}</td>
                                <td className="whitespace">{tdata.qa_type2}</td>
                                <td className="whitespace">{tdata.feedback}</td>
                              
                                <td>{tdata.phasefeedbackbyname}</td>
                                <td>{tdata.phaserejection_tm}</td>
                                <td onClick={()=> handleeditRow(i)}>
                                  {tdata.editing  && (user_info.role_id == 2 || user_info.role_id == 12 || user_info.role_id == 14) ? (
                                  
                                   <input type="date"
                                   className="form-control"
                                     defaultValue={tdata.phase_rejection_date}
                                     onBlur={(e) =>
                                      inputhandlerchecklist(
                                        e,
                                        "phase_rejection_date",
                                        i,tdata.id
                                      )}
                                   />
                                  ) : <span>{tdata.phase_rejection_date}</span> }
                              </td>
                                <td className="whitespace">{tdata.phase_type1}</td>
                                <td className="whitespace">{tdata.phase_type2}</td>
                                <td className="whitespace">{tdata.phase_feedback}</td>
                                </>
                                :
                                <>
                                  <td onClick={()=> handleeditRow(i)}>
                                    {tdata.editing  && (user_info.role_id == 2 || user_info.role_id == 12 || user_info.role_id == 14) ? (
                                    
                                    <input type="date"
                                    className="form-control"
                                      defaultValue={tdata.phase_rejection_date}
                                      onBlur={(e) =>
                                        inputhandlerchecklist(
                                          e,
                                          "phase_rejection_date",
                                          i,tdata.id
                                        )}
                                    />
                                    ) : <span>{tdata.phase_rejection_date}</span> }
                                  </td>
                                  <td className="whitespace">{tdata.phase_type1}</td>
                                  <td className="whitespace">{tdata.phase_type2}</td>
                                  <td className="whitespace">{tdata.phase_feedback}</td>
                                </>
                                }
                                <td className="whitespace" onClick={()=> handleeditRow(i)}>
                                  {tdata.editing && !phaseRejections ? (
                                    <select
                                      className="form-control"
                                      onChange={(e) =>
                                        inputhandlerchecklist(
                                          e,
                                          "rejection_type",
                                          i,tdata.id
                                        )
                                      }
                                      defaultValue={tdata.rejection_type}
                                    >
                                      <option value="">Select</option>
                                      <option value="Fatal">Fatal</option>
                                      <option value="Non-Fatal">Non-Fatal</option>
                                    </select>
                                  ) : (tdata.rejection_type!=null)?tdata.rejection_type:''}
                                </td>
                                <td className="whitespace" onClick={()=> handleeditRow(i)} >
                          {tdata.editing && !phaseRejections ? (
                          <input type="number"
                          className="form-control"
                            defaultValue={tdata.amount}
                          
                            onBlur={(e) =>
                              inputhandlerchecklist(
                                e,
                                "amount",
                                i,
                                tdata.id
                              )
                            }
                          />
                        ) : (
                          <span>{tdata.amount}</span>
                        )}
                      </td>
                      <td>
                        {tdata.automation_job ? 'Yes' : 'No'}
                      </td>
                      {isFullView ?
                      <>
                        <td className="whitespace" onClick={()=> canTrack && handleeditRow(i)}>
                          {tdata.editing && canTrack ? (
                            <select className="form-control" defaultValue={tdata.responsibility_option_id || ''}
                              onChange={(e) => trackinghandler(e.target.value, 'responsibility_option_id', i, tdata.id)}>
                              <option value="">Select</option>
                              {feedbackOptions.responsibility.map((o) => <option key={o.id} value={o.id}>{o.name}</option>)}
                            </select>
                          ) : tdata.responsibility_option}
                        </td>
                        <td className="whitespace" onClick={()=> canTrack && handleeditRow(i)}>
                          {tdata.editing && canTrack ? (
                            <textarea className="form-control" defaultValue={tdata.reason || ''}
                              onBlur={(e) => trackinghandler(e.target.value, 'reason', i, tdata.id)} />
                          ) : tdata.reason}
                        </td>
                        <td className="whitespace" onClick={()=> canTrack && handleeditRow(i)}>
                          {tdata.editing && canTrack ? (
                            <select className="form-control" defaultValue={tdata.applicable_phase_id || ''}
                              onChange={(e) => trackinghandler(e.target.value, 'applicable_phase_id', i, tdata.id)}>
                              {feedbackOptions.phases.map((o) => <option key={o.id} value={o.id}>{o.name}</option>)}
                            </select>
                          ) : tdata.applicable_team}
                        </td>
                        <td className="whitespace" onClick={()=> canTrack && handleeditRow(i)}>
                          {tdata.editing && canTrack ? (
                            <textarea className="form-control" defaultValue={tdata.root_cause || ''}
                              onBlur={(e) => trackinghandler(e.target.value, 'root_cause', i, tdata.id)} />
                          ) : tdata.root_cause}
                        </td>
                        <td className="whitespace" onClick={()=> canTrack && handleeditRow(i)}>
                          {tdata.editing && canTrack ? (
                            <textarea className="form-control" defaultValue={tdata.action_items || ''}
                              onBlur={(e) => trackinghandler(e.target.value, 'action_items', i, tdata.id)} />
                          ) : tdata.action_items}
                        </td>
                        <td className="whitespace" onClick={()=> canTrack && handleeditRow(i)}>
                          {tdata.editing && canTrack ? (
                            <select className="form-control" defaultValue={tdata.action_status_id || ''}
                              onChange={(e) => trackinghandler(e.target.value, 'action_status_id', i, tdata.id)}>
                              <option value="">Select</option>
                              {feedbackOptions.status.map((o) => <option key={o.id} value={o.id}>{o.name}</option>)}
                            </select>
                          ) : tdata.action_status}
                        </td>
                        <td className="whitespace" onClick={()=> canTrack && handleeditRow(i)}>
                          {tdata.editing && canTrack ? (
                            <input type="date" className="form-control" defaultValue={tdata.closure_date || ''}
                              onBlur={(e) => trackinghandler(e.target.value, 'closure_date', i, tdata.id)} />
                          ) : (tdata.closure_date ? moment(tdata.closure_date).format('DD-MM-YYYY') : '')}
                        </td>
                      </>
                      :null}
                                { user_info.role_id==14 || user_info.role_id==2 || user_info.role_id==12 ?
                                <td>
                                  {tdata.qa_rejection && (user_info.role_id==14 || user_info.role_id==2 || user_info.role_id==12) ? 
                                <button type="button" className="btn btn-danger" onClick={() => removeRow(tdata.id,'qa_rejection')}>
                                <i className="fa fa-remove"></i> QA Delete
                                </button> : null}
                                {tdata.phase_rejection ? 
                                <button type="button" cla ssName="btn btn-danger" onClick={() => removeRow(tdata.id,'phase_rejection')}>
                                <i className="fa fa-remove"></i> Phase Delete
                                </button> : null}
                                 
                                </td>:null}
                              </tr>
                            ))
                          :
                           ( <p>No Data Found</p> )}
                         
        
                </tbody>
              </Table>
              <CardFooter className="py-4">
                <nav aria-label="...">
                  <Pagination
                    className="pagination justify-content-end mb-0"
                    listClassName="justify-content-end mb-0"
                  >
                    <PaginationItem disabled={currentPage <= 1}>
                      <PaginationLink onClick={handlePreviousClick} previous />
                    </PaginationItem>
                    {[...Array(last_page)].map((page, i) => (
                      <PaginationItem
                        active={i + 1 === currentPage}
                        key={i + 1}
                      >
                        <PaginationLink
                          onClick={(e) => handlePageClick(e, i + 1)}
                        >
                          {i + 1}
                        </PaginationLink>
                      </PaginationItem>
                    ))}
                    <PaginationItem disabled={currentPage >= last_page}>
                      <PaginationLink onClick={handleNextClick} next />
                    </PaginationItem>
                  </Pagination>
                </nav>
              </CardFooter>
              
            </Card>
          </div>
        </Row>
        

      </Container>
    </>
  );
};


export default FeedbackChecklist;
